import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0811 5.919c3.3585 3.3584 3.3585 8.8036 0 12.1621-3.3585 3.3585-8.8037 3.3585-12.1622 0-3.3585-3.3585-3.3585-8.8037 0-12.1622 3.3585-3.3585 8.8037-3.3585 12.1622 0Zm1.4143 13.5764c4.1395-4.1396 4.1395-10.8512 0-14.9907C15.3558.365 8.6442.365 4.5047 4.5047.365 8.6442.365 15.3558 4.5047 19.4954c4.1395 4.1395 10.8511 4.1395 14.9907 0Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4754 7.1172c-.3536-.4243-.9841-.4816-1.4084-.128-.4243.3535-.4816.984-.1281 1.4084L14.1077 11H7.7574c-.5523 0-1 .4477-1 1 0 .5522.4477 1 1 1h6.3502l-2.1687 2.6024c-.3535.4243-.2962 1.0549.1281 1.4084.4243.3536 1.0548.2963 1.4084-.128l3.5355-4.2427a.9998.9998 0 0 0 0-1.2803l-3.5355-4.2427Z"
    />
  </>,
  'ArrowRightContained2'
)
